import { render, staticRenderFns } from "./userlogin.vue?vue&type=template&id=325ffe8e&scoped=true&"
import script from "./userlogin.vue?vue&type=script&lang=js&"
export * from "./userlogin.vue?vue&type=script&lang=js&"
import style0 from "./userlogin.vue?vue&type=style&index=0&id=325ffe8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ffe8e",
  null
  
)

export default component.exports